import React from 'react';
import { FullLockdown } from 'hfs-common-ui';
import { useTranslation } from 'react-i18next';
import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';
import { useAppStatusConfig } from '~/core/components/incident-communication/hooks/use-app-status-config';
import { appInfo } from '~/config/app';

const LOGO_URL = '/images/logo_lockdown.svg';
const BACKGROUND_URL = '/images/hfs_full_lockdown_bg.png';

const IncidentLockdown = () => {
  const { t } = useTranslation([InternationalizationNameSpace.IncidentCommunication]);
  const config = useAppStatusConfig();

  return (
    <FullLockdown
      logo={LOGO_URL}
      logoAlt={appInfo.appName}
      icon="notification.info_outlined"
      backgroundImage={BACKGROUND_URL}
      title={t(`incidentCommunication.lockdown.${config.lockdownTitle}.title`)}
      message={t(`incidentCommunication.lockdown.${config.lockdownMessage}.message`, {
        name: appInfo.appName,
      })}
    />
  );
};

export default IncidentLockdown;
